var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntiCalcaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.336,
    height: 53.336,
    viewBox: "0 0 53.336 53.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 53.336,
    height: 53.336,
    rx: 15,
    fill: "#8d5c99",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 29.75,
    height: 27.911,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_335",
    "data-name": "Groupe 335",
    transform: "translate(110.246 -2747.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANTI_CALCAIRE",
    "data-name": "ANTI CALCAIRE",
    transform: "translate(-110.246 2747.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_8",
    "data-name": "Groupe de masques 8",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 53.336,
    height: 53.336,
    transform: "translate(0 0)",
    fill: "#8d5c99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_246",
    "data-name": "Groupe 246",
    transform: "translate(12.59 21.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_245",
    "data-name": "Groupe 245",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_306",
    "data-name": "Trac\\xE9 306",
    d: "M326.207,130.078q-.136,0-.273-.009a4.086,4.086,0,0,1-3.581-5.448.6.6,0,0,1,.078-.24l.073-.126a4.092,4.092,0,0,1,.35-.6l2.881-4.974c.016-.038.026-.064.031-.079a.6.6,0,0,1,1.129-.1l.072.153,3.021,5.755a.6.6,0,0,1,.066.218,4.087,4.087,0,0,1-3.846,5.457m-2.652-5.231a.61.61,0,0,1-.022.063,2.869,2.869,0,0,0-.194,1.4,2.9,2.9,0,0,0,2.672,2.557,2.881,2.881,0,0,0,2.862-3.956.61.61,0,0,1-.028-.089l-2.508-4.777-2.454,4.236q-.014.024-.03.047a2.874,2.874,0,0,0-.267.461c-.008.017-.016.034-.026.05Zm3.318-6h0m0,0h0m-1.109-.242,0,.009,0-.009",
    transform: "translate(-300.54 -110.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 2.478,
    height: 25.848,
    transform: "translate(0 1.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 2.478,
    height: 8.251,
    transform: "translate(24.559 19.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 2.478,
    height: 8.206,
    transform: "translate(24.559 1.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_307",
    "data-name": "Trac\\xE9 307",
    d: "M48.88,7.53a1.4,1.4,0,1,1-1.4-1.4,1.4,1.4,0,0,1,1.4,1.4",
    transform: "translate(-42.989 -5.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_308",
    "data-name": "Trac\\xE9 308",
    d: "M168.369,73.913a1.4,1.4,0,1,1-1.4-1.4,1.4,1.4,0,0,1,1.4,1.4",
    transform: "translate(-154.474 -67.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_309",
    "data-name": "Trac\\xE9 309",
    d: "M112.2,174a1.4,1.4,0,1,1-1.4-1.4,1.4,1.4,0,0,1,1.4,1.4",
    transform: "translate(-102.066 -161.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_310",
    "data-name": "Trac\\xE9 310",
    d: "M276.624,166.849a1.4,1.4,0,1,1-1.4-1.4,1.4,1.4,0,0,1,1.4,1.4",
    transform: "translate(-255.477 -154.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_311",
    "data-name": "Trac\\xE9 311",
    d: "M185.731,292.466a1.4,1.4,0,1,1-1.4-1.4,1.4,1.4,0,0,1,1.4,1.4",
    transform: "translate(-170.673 -271.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_312",
    "data-name": "Trac\\xE9 312",
    d: "M277.646,376.211a1.4,1.4,0,1,1-1.4-1.4,1.4,1.4,0,0,1,1.4,1.4",
    transform: "translate(-256.431 -349.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_313",
    "data-name": "Trac\\xE9 313",
    d: "M275.133,273.849a2.189,2.189,0,1,1-2.189-2.189,2.189,2.189,0,0,1,2.189,2.189",
    transform: "translate(-252.619 -253.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_314",
    "data-name": "Trac\\xE9 314",
    d: "M82.112,63.466a2.189,2.189,0,1,1-2.189-2.189,2.189,2.189,0,0,1,2.189,2.189",
    transform: "translate(-72.527 -57.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_315",
    "data-name": "Trac\\xE9 315",
    d: "M255.729,54.274a2.189,2.189,0,1,1-2.189-2.189,2.189,2.189,0,0,1,2.189,2.189",
    transform: "translate(-234.514 -48.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_316",
    "data-name": "Trac\\xE9 316",
    d: "M65.771,255.466a2.189,2.189,0,1,1-2.189-2.189,2.189,2.189,0,0,1,2.189,2.189",
    transform: "translate(-57.281 -236.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_317",
    "data-name": "Trac\\xE9 317",
    d: "M197.78,189.215a1.3,1.3,0,1,1-1.3-1.3,1.3,1.3,0,0,1,1.3,1.3",
    transform: "translate(-182.106 -175.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_318",
    "data-name": "Trac\\xE9 318",
    d: "M133.44,1.3a1.3,1.3,0,1,1-1.3-1.3,1.3,1.3,0,0,1,1.3,1.3",
    transform: "translate(-122.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_319",
    "data-name": "Trac\\xE9 319",
    d: "M121.185,355.683a1.3,1.3,0,1,1-1.3-1.3,1.3,1.3,0,0,1,1.3,1.3",
    transform: "translate(-110.642 -330.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_320",
    "data-name": "Trac\\xE9 320",
    d: "M355.836,221.579a2.225,2.225,0,0,1-1.934-1.336,5.181,5.181,0,0,1-.489-1.345.569.569,0,0,1,1.118-.215c.005.026.4,1.881,1.42,1.75a.569.569,0,0,1,.146,1.129,2.047,2.047,0,0,1-.262.017",
    transform: "translate(-329.73 -203.604)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Anti-_calcaire",
    "data-name": "Anti- calcaire",
    d: "M7.255,8.132a.185.185,0,0,1-.036,0,.179.179,0,0,1-.034-.01A.2.2,0,0,1,7.153,8.1a.235.235,0,0,1-.031-.024q-.059-.055-.059-.137,0-.037.018-.082l2.2-5.9q.027-.091.105-.16t.215-.069h1q.137,0,.21.069t.11.16l2.2,5.9q.009.046.009.082,0,.082-.055.137a.208.208,0,0,1-.029.024.176.176,0,0,1-.031.017.167.167,0,0,1-.033.01.18.18,0,0,1-.035,0h-.8a.451.451,0,0,1-.06,0,.3.3,0,0,1-.051-.011A.211.211,0,0,1,12,8.1a.166.166,0,0,1-.034-.026q-.059-.059-.078-.114l-.43-1.116H8.746l-.43,1.116q-.018.055-.078.114A.166.166,0,0,1,8.2,8.1a.211.211,0,0,1-.043.019.3.3,0,0,1-.051.011.451.451,0,0,1-.06,0ZM9.066,5.79h2.077L10.1,2.963ZM14.1,8.132a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V3.594q0-.091.064-.156t.156-.064h.75q.091,0,.156.064t.064.156v.375q.238-.293.608-.489t.919-.2q.558,0,.97.252t.636.709q.224.457.224,1.1V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0H17.4a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V5.4q0-.531-.261-.833t-.755-.3q-.476,0-.759.3t-.284.833V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Zm7.584,0q-.549,0-.924-.192T20.2,7.368q-.183-.38-.183-.947V4.345h-.723q-.091,0-.156-.064t-.064-.156V3.594q0-.091.064-.156t.156-.064h.723V1.856q0-.091.059-.156t.16-.064h.741q.091,0,.156.064t.064.156V3.375h1.144q.091,0,.156.064t.064.156v.531q0,.091-.064.156t-.156.064H21.2V6.33q0,.375.133.586t.462.21h.631q.091,0,.156.064t.064.156v.567q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Zm1.994,0a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V3.594q0-.091.064-.156t.156-.064h.759q.1,0,.16.064t.059.156V7.913q0,.091-.059.156a.2.2,0,0,1-.032.028.191.191,0,0,1-.037.02.216.216,0,0,1-.043.012.273.273,0,0,1-.048,0ZM23.64,2.588q-.1,0-.16-.059t-.059-.16V1.71q0-.091.059-.156t.16-.064h.833q.1,0,.165.064t.064.156v.659q0,.1-.064.16t-.165.059Zm2.424,3.321q-.1,0-.16-.064t-.059-.156v-.6q0-.091.059-.156t.16-.064h2.809q.091,0,.156.064t.064.156v.6q0,.091-.064.156t-.156.064ZM3.577,16.356q-.659,0-1.157-.247t-.778-.718q-.279-.471-.306-1.139-.009-.137-.009-.361t.009-.371q.027-.668.306-1.139t.778-.718q.5-.247,1.157-.247.586,0,1,.165t.677.412q.265.247.4.517T5.791,13q.009.1-.059.16t-.16.059H4.766q-.091,0-.142-.046t-.1-.137q-.137-.366-.361-.517T3.6,12.367q-.457,0-.727.288t-.288.91q-.018.348,0,.64.018.631.288.915T3.6,15.4q.357,0,.576-.151t.357-.517q.046-.091.1-.137t.142-.046h.805q.091,0,.16.059t.059.16q-.009.165-.087.371t-.247.421q-.169.215-.425.393t-.618.288Q4.053,16.356,3.577,16.356Zm4.547,0q-.476,0-.86-.188t-.608-.5q-.224-.316-.224-.709,0-.64.517-1.02t1.368-.508l1.253-.183v-.192q0-.384-.192-.595t-.659-.21q-.329,0-.535.133t-.306.352q-.073.119-.21.119H6.944q-.1,0-.151-.055t-.05-.146q.009-.146.119-.357t.348-.407q.238-.2.613-.334t.906-.137q.576,0,.974.142t.636.38q.238.238.348.558t.11.677v2.873q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.237.237,0,0,1-.044,0H9.835a.274.274,0,0,1-.048,0,.216.216,0,0,1-.043-.012.191.191,0,0,1-.037-.02.2.2,0,0,1-.032-.028q-.059-.064-.059-.156v-.357q-.119.174-.32.325t-.489.247Q8.517,16.356,8.124,16.356Zm.311-.869q.32,0,.581-.137t.412-.425q.151-.288.151-.727V14l-.915.146q-.54.082-.805.265t-.265.448q0,.2.124.343t.316.21Q8.225,15.487,8.435,15.487Zm3.76.778a.237.237,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V9.988q0-.091.064-.156t.156-.064h.759q.091,0,.156.064t.064.156v6.056q0,.091-.064.156a.231.231,0,0,1-.034.028A.205.205,0,0,1,13,16.26a.237.237,0,0,1-.044,0Zm4.254.091q-.659,0-1.157-.247t-.778-.718q-.279-.471-.306-1.139-.009-.137-.009-.361t.009-.371q.027-.668.306-1.139t.778-.718q.5-.247,1.157-.247.586,0,1,.165t.677.412q.265.247.4.517t.142.489q.009.1-.059.16t-.16.059h-.805q-.091,0-.142-.046t-.1-.137q-.137-.366-.361-.517t-.572-.151q-.457,0-.727.288t-.288.91q-.018.348,0,.64.018.631.288.915t.727.284q.357,0,.576-.151t.357-.517q.046-.091.1-.137t.142-.046h.805q.091,0,.16.059t.059.16q-.009.165-.087.371t-.247.421q-.169.215-.425.393t-.618.288Q16.925,16.356,16.449,16.356Zm4.547,0q-.476,0-.86-.188t-.608-.5q-.224-.316-.224-.709,0-.64.517-1.02t1.368-.508l1.253-.183v-.192q0-.384-.192-.595t-.659-.21q-.329,0-.535.133t-.306.352q-.073.119-.21.119h-.723q-.1,0-.151-.055t-.05-.146q.009-.146.119-.357t.348-.407q.238-.2.613-.334t.906-.137q.576,0,.974.142t.636.38q.238.238.348.558t.11.677v2.873q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.237.237,0,0,1-.044,0h-.741a.274.274,0,0,1-.048,0,.216.216,0,0,1-.043-.012.191.191,0,0,1-.037-.02.2.2,0,0,1-.032-.028q-.059-.064-.059-.156v-.357q-.119.174-.32.325t-.489.247Q21.39,16.356,21,16.356Zm.311-.869q.32,0,.581-.137t.412-.425q.151-.288.151-.727V14l-.915.146q-.54.082-.805.265t-.265.448q0,.2.124.343t.316.21Q21.1,15.487,21.307,15.487Zm3.751.778a.237.237,0,0,1-.044,0,.205.205,0,0,1-.078-.032A.231.231,0,0,1,24.9,16.2q-.064-.064-.064-.156V11.727q0-.091.064-.156t.156-.064h.759q.1,0,.16.064t.059.156v4.318q0,.091-.059.156a.2.2,0,0,1-.032.028.191.191,0,0,1-.037.02.216.216,0,0,1-.043.012.274.274,0,0,1-.048,0Zm-.037-5.544q-.1,0-.16-.059T24.8,10.5V9.842q0-.091.059-.156t.16-.064h.833q.1,0,.165.064t.064.156V10.5q0,.1-.064.16t-.165.059Zm2.452,5.544a.237.237,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V11.736q0-.1.064-.165t.156-.064h.741q.091,0,.16.064t.069.165v.375q.21-.293.544-.448t.773-.156h.375q.1,0,.16.064t.059.156v.659q0,.091-.059.156t-.16.064h-.714q-.439,0-.682.247t-.242.677v2.516q0,.091-.064.156a.216.216,0,0,1-.034.028.208.208,0,0,1-.039.02.228.228,0,0,1-.043.012.279.279,0,0,1-.048,0Zm5.581.091q-1.015,0-1.61-.586t-.64-1.665q-.009-.091-.009-.233t.009-.224q.037-.686.316-1.189t.773-.773q.494-.27,1.162-.27.741,0,1.244.306t.759.851q.256.544.256,1.258v.192q0,.091-.064.156t-.165.064H32.048t0,.027q0,.027,0,.046.009.32.124.59t.339.435q.224.165.535.165.256,0,.43-.078t.284-.178q.11-.1.156-.165.082-.11.133-.133t.151-.023h.787q.091,0,.151.055t.05.137q-.009.146-.151.357t-.407.412q-.265.2-.663.334T33.054,16.356Zm-1.006-2.882H34.07v-.027q0-.357-.119-.622T33.6,12.4q-.229-.156-.549-.156t-.549.156q-.229.156-.343.421t-.114.622Z",
    transform: "translate(7.509 2.042)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiCalcaire);
export default __webpack_public_path__ + "static/media/ANTI_CALCAIRE.119a74d946cba5be22e53be348e3bce2.svg";
export { ForwardRef as ReactComponent };